import { Entity } from '@app/core';
import { ReportScope } from '@games/interfaces';

export interface GroupPermission {
  id: number;
  name: string;
  has_access: boolean;
}

export interface ReportPermission {
  id: number;
  name: string;
  report_scope: string;
  group_permissions?: GroupPermission[];
}

export interface ReportPermissionResponse {
  reports: ReportPermission[];
}

export interface IReportEntity {
  id: number;
  name: string;
  reportScope: ReportScope | string;
  reportScopeLabel?: string;
  groupPermissions?: GroupPermission[];
}

export class ReportEntity extends Entity<IReportEntity> {
  constructor(props: IReportEntity) {
    super(props);
  }

  get id(): number {
    return this.props.id;
  }

  get name(): string {
    return this.props.name;
  }

  get scope(): ReportScope | string {
    return this.props.reportScope;
  }

  get scopeLabel(): string {
    return this.props.reportScopeLabel ?? '';
  }

  get groupPermissions(): GroupPermission[] {
    return this.props.groupPermissions ?? [];
  }

  get isEntity(): boolean {
    return this.props.reportScope === ReportScope.ENTITY || this.props.reportScope === 'Entity';
  }

  get isEconomy(): boolean {
    return this.props.reportScope === ReportScope.ECONOMY || this.props.reportScope === 'Economy';
  }

  get isMarket(): boolean {
    return this.props.reportScope === ReportScope.MARKET || this.props.reportScope === 'Market';
  }

  hasAccess(groupId: number): boolean {
    return this.groupPermissions.some(gp => gp.id === groupId && gp.has_access);
  }
}

// Backward compatibility alias
export { ReportEntity as ReportType };
